<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5Ucxng/tc-custom/9781398489066.jpg?1705766048028" alt="This image is the cover for the book Time – Space – Taste"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Time – Space – Taste
      </h1>
      <p class="bookDescription body article font2">
        <p>A short guide to the mysteries of time, space, and the nature of existence as expressed in various media. The author records his own views on time and space mysteries with accompanying food, art, and music recommendations, all in a tongue-in-cheek fashion. It contains passages from Shakespeare, Goethe, Brooke, Nietzsche, Housman, Tennyson, T.S. Eliot, Milton, Shelley, Yeats, Sassoon, Blake, Hardy, Kipling, the Bible, and other sources. Some aspects of Einstein’s theories and astrophysics are covered with minimal mathematics. The author has created seven full-page illustrations to augment the text. This book can be ‘dipped into’ at any page and the author hopes it will amuse and inform in an easy-to-understand way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Max Artusov
      </h2>
      
      <p class="authorDescription body article">The author attended both Oxford and Cambridge (Football matches). He received unnoticed critical acclaim for putting the ‘Ding’ into reading, the ‘Sex’ into Middlesex and something into Scunthorpe. His ambition is to take the ‘Woke’ out of Wokingham. He currently lives somewhere. He drinks, eats and smokes too much, is overweight and is rather curmudgeonly. He has reached that point in life when everything annoys him. He does not support a football team and has no slippers. Quite frankly, he just doesn’t care whether you buy the book or not. He doesn’t need the money.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aad49724